<div class="subBlockContainer">
    <div class="subBlockContent" id="price-list-summary">
      <child-header [title]="title" (closeEvent)="close()"></child-header>

      <div class="inner-subBlock-wrapper">
<!--            <div class="page-title-wrapper">-->
<!--                <div class="title blade-title-font">-->
<!--                    {{title}}-->
<!--                </div>-->
<!--                <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>-->
<!--            </div>-->
            <div class="top-divider"></div>

            <div class="shared-outer-wrapper">
                <table matSort (matSortChange)="sortData($event)" class="white">
                    <thead>
                        <tr class="row">
                            <th mat-sort-header="stockDesc" class="col-2">STOCK CODE</th>
                            <th mat-sort-header="stockOnHand" class="col-6">DESCRIPTION</th>
                            <th mat-sort-header="price" class="col-1">QTY</th>
                            <th mat-sort-header="quantity" class="col-1" style="padding-left: 23px">PRICE</th>
                            <th mat-sort-header="lineTotal" class="col-2"
                                style="padding-left: 28px; padding-right: auto;">
                                SUBTOTAL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let item of sortedData| TableFilterMultiple:['stockDesc',
                    'stockOnHand', 'price', 'quantity', 'lineTotal'] : filterInput ; index as i">
                            <tr class="row">
                                <div class="col-2">

                                    {{item?.stockCode}}
                                </div>
                                <div class="col-6 align-left center-text font-color padding-r-x30"
                                    *ngIf="item?.stockType != 'CB' && item?.stockType != 'KA' && item?.stockType != 'LC' && !item?.stockType.startsWith('N') && item?.stockType != 'GT' && item?.stockType != 'ST'">
                                    <div class="result_desc">
                                        {{item?.stockDesc}}
                                    </div>
                                </div>
                                <div class="col-1 align-center center-text font-color padding-r-x30"
                                    *ngIf="item?.stockType == 'CB' || item?.stockType == 'KA' || item?.stockType == 'LC' || item?.stockType == 'GT' || item?.stockType == 'ST'">
                                </div>
                                <div class="col-1 align-left center-text font-color padding-r-x25"
                                    *ngIf="item?.stockType != 'CB' && item?.stockType != 'KA' && !item?.stockType.startsWith('N')&& item?.stockType != 'GT' && item?.stockType != 'ST'">
                                    {{item.quantity}}
                                </div>
                                <div class="col-1 align-right center-text font-color padding-r-x25"
                                    *ngIf="item?.stockType == 'CB' || item?.stockType == 'KA' || item?.stockType == 'GT' || item?.stockType == 'ST'">
                                </div>
                                <div class="col-1 align-center font-color margin-t-x4"
                                    *ngIf="!item?.stockType.startsWith('N') && item?.stockType != 'GT' && item?.stockType != 'ST'">
                                    <div class="quantity">{{item?.price | currency:'AUD':'symbol-narrow':'.2-2'}}
                                    </div>
                                </div>
                                <div class="col-1 align-center center-text font-color"
                                    *ngIf="item?.stockType == 'GT' || item?.stockType == 'ST'"></div>
                                <div class="col-2 align-right center-text font-color padding-r-x70"
                                    *ngIf="item?.stockType != 'CB' && item?.stockType != 'KA' && !item?.stockType.startsWith('N')">
                                    {{item?.lineTotal | currency:'AUD':'symbol-narrow':'.2-2'}}</div>
                                <div class="col-2 align-right center-text font-colo padding-r-x70r"
                                    *ngIf="item?.stockType != 'CB' || item?.stockType != 'KA'"></div>

                                <!-- <div class="col-6 col-offset-2">
                                <div class="result-info">
                                    <div class="produc-secondary-title-wrapper">
                                        <span>
                                            <span class="bold-text">Min:&nbsp;</span>
                                            <span>{{item?.min}}</span>
                                        </span>

                                        <span style="margin-left: 4rem;">
                                            <span class="bold-text">Max:&nbsp;</span>
                                            <span>{{item?.max}}</span>
                                        </span>
                                    </div>
                                </div>
                            </div> -->

                            </tr>
                        </ng-container>
                        <tr class="row totalPrice-wrapper">

                            <div class="col-md offset-md-7">Total (ex. GST)</div>
                            <div class="col-md price">
                                {{total | currency:'AUD':'symbol-narrow':'.2-2'}}</div>
                            <div class="col-md-1" style="max-width: 5%"></div>

                            <div class="col-12 align-center mt-4">
                                <button class="button button-red button-large" (click)="checkOut()">Checkout</button>
                            </div>

                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="button-wrapper" style="text-align: center;">
                <!-- <button class="button button-red button-large placeOrderbtn">Place order</button> -->
            </div>

        </div>
        <loading-screen *ngIf="!loadContent"  [isScrolled]="true" (currentLoadingStatus)="onLoading($event)">
        </loading-screen>
    </div>
    <router-outlet></router-outlet>
</div>
